import { Component, OnInit, Input } from '@angular/core';
import { SurveyFull } from 'src/app/common/survey-full';
import { UntypedFormGroup, UntypedFormBuilder, FormArray, Validators, FormControl } from '@angular/forms';
import { QuestionBase } from 'src/app/common/question-base';
import { QuestionControlService } from 'src/app/services/question-control.service';
import { SurveyResponse } from 'src/app/common/survey-response';
import { Answer } from 'src/app/common/answer';
import { DbServiceService } from 'src/app/services/db-service.service';
import { Router } from '@angular/router';
import * as uuid from 'uuid';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ResultsComponent } from 'src/app/components/results/results.component';
import { catchError, of, throwError } from 'rxjs';

@Component({
  selector: 'app-take-survey-questions',
  templateUrl: './take-survey-questions.component.html',
  styleUrls: ['./take-survey-questions.component.css'],
})

export class TakeSurveyQuestionsComponent implements OnInit {

  @Input() surveyId: number;

  survey: SurveyFull;
  questions: QuestionBase<string>[];
  form: UntypedFormGroup;
  reportData: SafeResourceUrl = "";
  loaderData: SafeResourceUrl = "";

  surveyResponse: SurveyResponse;

  questionCounter: number = 0;
  selectedIndex: number = 0;
  latestIndex: number = 0;
  submitted: number = 0;
  isLoading: boolean = true;
  loadingURL: string = location.origin + "/ibg-eforms/sg/sustainability-accel-tool/assets/static/loading.html";
  notLastPage: boolean = true;
  errMsg: string = "";

  pillars_top: string[] = [
    "",
    "Pillar 1",
    "Pillar 2",
    "Pillar 3",
    "Pillar 4",
    "",
    "",
  ];

  pillars_bottom: string[] = [
    "About Your Business",
    "Governance Framework",
    "Sustainability Strategy",
    "Risk & Opportunities",
    "Metrics & Targets",
    "Contact<br>Details",
    "View the Results",
  ];

  pillars_top_text: string[] = [
    "",
    "Pillar 1",
    "Pillar 2",
    "Pillar 3",
    "Pillar 4",
    "",
    "",
  ];

  pillars_bottom_text: string[] = [
    "About Your Business",
    "Governance Framework",
    "Sustainability Strategy",
    "Risk & Opportunities",
    "Metrics & Targets",
    "Contact Details",
    "View the Results",
  ];

  paginations: number[] = [
     1,
     13,
     20,
     25,
     29,
     42,
     50,
  ];

  visibilityMatrix: Map<string, string[]> = new Map<string, string[]>([
     [ "6", [ "hide", "5", "Yes" ] ],
     [ "7", [ "show", "6", "Others" ] ],
     [ "10", [ "show", "8", "Singapore" ] ],
     [ "9", [ "show", "8", "Others" ] ],
     [ "17", [ "show", "16", "Yes" ] ],
     [ "18", [ "show", "17", "Others (Please Specify Below)" ] ],
     [ "32", [ "show", "31", "Yes" ] ],
     [ "34", [ "show", "33", "Yes" ] ],
     [ "35", [ "show", "33", "Yes" ] ],
     [ "36", [ "show", "33", "Yes" ] ],
     [ "37", [ "show", "33", "Yes" ] ],
     [ "38", [ "show", "33", "Yes" ] ],
     [ "39", [ "show", "33", "Yes" ] ],
     [ "40", [ "show", "33", "Yes" ] ],
     [ "45", [ "show", "44", "Others" ] ],
     [ "47", [ "show", "46", "Others" ] ],
  ]);

  hintMatrix: Map<string, string> = new Map<string, string>([
     [ "43", "The full report will be emailed to your business email address indicated above." ],
  ]);

  placeholderMatrix: Map<string, string> = new Map<string, string>([
     [ "35", "YYYY" ],
  ]);

  // disclaimerText: string = "By providing your business contact information in this form, we may periodically send you electronic direct mailers on updated information and new services relating to DBS.";
  disclaimerText: string = "";

  subnumberedMatrix: string[] = [
     "17",
     "32",
     "34",
  ];

  unnumberedMatrix: string[] = [
     "1",
     "2",
     "3",
     "4",
     "5",
     "6",
     "7",
     "8",
     "9",
     "10",
     "11",
     "12",
     "17",
     "18",
     "32",
     "34",
     "35",
     "36",
     "37",
     "38",
     "39",
     "40",
     "42",
     "43",
     "44",
     "45",
     "46",
     "47",
     "48",
     "49",
  ];

  informationMatrix = {
    13:
        [ [ "regularly", "Regularly:", "You engage with stakeholders at least twice a year" ],
          [ "stakeholders", "Stakeholder:", "Individual or group that has an interest that is affected or could be affected by the company's activities" ],
          [ "sustainability matters", "Sustainability matters:", "Refers to the following but it is not limited to, identifying key stakeholders, key material topics, key performance metrics and sustainability strategy" ],
        ],
    14: [ [ "senior executives", "Senior executive:", "Higher-ranking people in a company's management team to be delegated the responsibility in overseeing the sustainability agenda." ] ],
    15: [ [ "regularly", "Regular:", "You hold management discussions at least quarterly" ] ],
    16: [ [ "similar documents", "Similar documents:", "Impact reports, sustainability reports and performance highlights" ] ],
    19: [ [ "sustainability data", "Sustainability data:", "The data metrics that measure how resources are used or generated in relation to sustainability goals. It includes data on energy, water, materials, waste, etc." ] ],
    20:
        [ [ "sustainability-related risks", "Sustainability-related risks:", "Risks that arise from the environmental, social, and governance impacts of a company's activities. They can affect the financial performance, reputation, compliance, and competitiveness of a company." ],
          [ "opportunities", "Sustainability-related opportunities:", "Opportunities that arise from the environmental, social, and governance impacts of a company's activities. They can affect the financial performance, reputation, compliance, and competitiveness of a company." ],
        ],
    21:
        [ [ "sustainability risks", "Sustainability-related risks:", "Risks that arise from the environmental, social, and governance impacts of a company's activities. They can affect the financial performance, reputation, compliance, and competitiveness of a company." ],
          [ "opportunities", "Sustainability-related opportunities:", "Opportunities that arise from the environmental, social, and governance impacts of a company's activities. They can affect the financial performance, reputation, compliance, and competitiveness of a company." ],
          [ "value chain", "Value chain:", "Upstream and downstream life cycle of a product, process, or service.\n\nUpstream activities include operations that relate to the initial stages of producing a good or service.\n\nDownstream activities include operations that relate to processing the materials into a finished product and delivering to the end user." ],
        ],
    23: [ [ "stakeholders", "Stakeholder:", "Individual or group that has an interest that is affected or could be affected by the company's activities" ] ],
    25:
        [ [ "sustainability risks", "Sustainability-related risks:", "Risks that arise from the environmental, social, and governance impacts of a company's activities. They can affect the financial performance, reputation, compliance, and competitiveness of a company." ],
          [ "opportunities", "Sustainability-related opportunities:", "Opportunities that arise from the environmental, social, and governance impacts of a company's activities. They can affect the financial performance, reputation, compliance, and competitiveness of a company." ],
        ],
    26: [ [ "sustainability risks", "Sustainability-related risks:", "Risks that arise from the environmental, social, and governance impacts of a company's activities. They can affect the financial performance, reputation, compliance, and competitiveness of a company." ] ],
    27: [ [ "sustainability risks", "Sustainability-related risks:", "Risks that arise from the environmental, social, and governance impacts of a company's activities. They can affect the financial performance, reputation, compliance, and competitiveness of a company." ] ],
    28: [ [ "sustainability risk", "Sustainability-related risks:", "Risks that arise from the environmental, social, and governance impacts of a company's activities. They can affect the financial performance, reputation, compliance, and competitiveness of a company." ] ],
    29: [ [ "sustainability topics", "Sustainability topics:", "Topics that the organisation prioritises based on the most significant impacts that it has on the economy, environment, and people." ] ],
    30:
        [ [ "key performance indicators", "Key Performance Indicators (KPIs):", "Identified metrics used to evaluate a company's sustainability performance for its material topics according to the respective Environmental, Social and Governance aspect" ],
          [ "sustainability topics", "Sustainability topics:", "Topics that the organisation prioritises based on the most significant impacts that it has on the economy, environment, and people." ],
        ],
    33: [ [ "regularly", "Regularly:", "You maintain a track record of sustainability performance indicators data spanning at least 3 years." ] ],
  };

  isSubnumbered(id): boolean {
     return (this.subnumberedMatrix.includes(id));
  }

  isNumbered(id): boolean {
     return (!this.unnumberedMatrix.includes(id));
  }

  getPlaceholder(question): string {
     var result = "";
     let id = question.key;
     if (this.placeholderMatrix.has(id)) {
       result = this.placeholderMatrix.get(id);
     }
     return result;
  }

  getMarkers(id) {
     return this.informationMatrix[id];
  }

  getHint(question): string {
     var result = "";
     let id = question.key;
     if (this.hintMatrix.has(id)) {
       result = this.hintMatrix.get(id);
     }
     return result;
  }

  showQuestion(question, questions, controls): boolean {
     let id = question.key;
     let result = false;

     if (this.visibilityMatrix.has(id)) {

         let criteria = this.visibilityMatrix.get(id);
         let referenceId = parseInt(criteria[1]) - 1;
         let reference = controls[criteria[1]];

         if (this.submitted || reference.valid) {

            let option;

            if (reference.value) {
              reference = reference.value;

              if (questions[referenceId].controlType == 'checklist') {
                  let mapped = questions[referenceId].options.map((option, index) => {
                    if (reference[index]) {
                      return option.key;
                    }
                  });

                  if (mapped) reference = mapped;
              }

              if (Array.isArray(reference)) {
                option = reference.map((refval) => { 
                  let actualValue = questions[referenceId].options.find((option) => {
                    return option.key == refval;
                  });

                  if (actualValue) {
                    return actualValue.value;
                  }
                });

                if (option) {
                  if (criteria[0] == "show") {
                    if (Array.isArray(option)) {
                      if (option.includes(criteria[2])) {
                        result = true;
                      } else {
                        result = false;
                      }
                    } else {
                      if (option == criteria[2]) {
                        result = true;
                      } else {
                        result = false;
                      }
                    }
                  } else {
                    if (Array.isArray(option)) {
                      if (option.includes(criteria[2])) {
                        result = false;
                      } else {
                        result = true;
                      }
                    } else {
                      if (option == criteria[2]) {
                        result = false;
                      } else {
                        result = true;
                      }
                    }
                  }
                } else {
                  result = false;
                }
              } else {
                option = questions[referenceId].options.find((option) => {
                    return option.key === reference;
                });

                if (option && option.value) {
                  option = option.value;
                  if (criteria[0] == "show") {
                    if (Array.isArray(option)) {
                      if (option.includes(criteria[2])) {
                        result = true;
                      } else {
                        result = false;
                      }
                    } else {
                      if (option == criteria[2]) {
                        result = true;
                      } else {
                        result = false;
                      }
                    }
                  } else {
                    if (Array.isArray(option)) {
                      if (option.includes(criteria[2])) {
                        result = false;
                      } else {
                        result = true;
                      }
                    } else {
                      if (option == criteria[2]) {
                        result = false;
                      } else {
                        result = true;
                      }
                    }
                  }
                } else {
                  result = false;
                }
              }
            } else {
            }
         }
     } else {
       result = true;
     }

     return result;
  }

  uuid: string = uuid.v4();
  emailField: number = 42;

  constructor(private fb: UntypedFormBuilder, private qcs: QuestionControlService,
    private dbService: DbServiceService, private router: Router, private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.loaderData = this.sanitizer.bypassSecurityTrustResourceUrl(this.loadingURL);
    this.reportData = this.sanitizer.bypassSecurityTrustResourceUrl(this.loadingURL);

    this.questions = [];
    this.form = new UntypedFormGroup({});
    this.initSurvey();
  }

  private createObject(): void {
    // create survey response object to send to backend 
    const answers: Answer[] = [];
    var answer: Answer;
    // we need to find selected ids and labels in case of checkbox question
    this.questions.forEach(question => {
      const id = question.key;
      const qId: number = +question.key;
      const qText: string = question.label;
      const qTypeText: string = question.controlType;
      let selectedOptionIds: string = "";
      let answerText: string = "";
      if (qTypeText === "radio" || qTypeText === "dropdown") {  // working
        // form contains option id, get id of selected option from form and use that
        // id to get text of option
        selectedOptionIds = this.form.get(id).value;
        const options = question.options;

        if (options.length > 0) {
           answerText = this.getValueFromKey(options, selectedOptionIds);
        } else {
           answerText = "-";
        }
      } else if (qTypeText === "checkbox") {  // working
        // form contains an array of boolean
        const isChecked: Array<boolean> = this.form.get(id).value;
        const options = question.options;
        let selectedOptions: Array<number> = [];  // array of id of selected options
        for (let i = 0; i < options.length; i++) {
          if (isChecked[i]) {
            selectedOptions.push(+options[i].key);
          }
        }

        // if one or more checkbox selected, do further processing
        if (selectedOptions.length > 0) {
          selectedOptionIds = selectedOptions[0].toString();
          answerText = this.getValueFromKey(options, selectedOptions[0].toString());

          for (let i = 1; i < selectedOptions.length; i++) {
            selectedOptionIds += " " + selectedOptions[i];
            answerText += " | " + this.getValueFromKey(options, selectedOptions[i].toString());
          }
        }
      } else if (qTypeText === "boolean") {
        const isChecked: boolean = this.form.get(id).value;
        const options = question.options;
        if (isChecked) {
            selectedOptionIds = options[0].key;
            answerText = this.getValueFromKey(options, options[0].key);
        }
      } else if (qTypeText === "checklist") {
        // form contains an array of boolean
        const isChecked: Array<boolean> = this.form.get(id).value;
        const options = question.options;
        let selectedOptions: Array<number> = [];  // array of id of selected options
        for (let i = 0; i < options.length; i++) {
          if (isChecked[i]) {
            selectedOptions.push(+options[i].key);
          }
        }

        // if one or more checkbox selected, do further processing
        if (selectedOptions.length > 0) {
          selectedOptionIds = selectedOptions[0].toString();
          answerText = this.getValueFromKey(options, selectedOptions[0].toString());

          for (let i = 1; i < selectedOptions.length; i++) {
            selectedOptionIds += " " + selectedOptions[i];
            answerText += " | " + this.getValueFromKey(options, selectedOptions[i].toString());
          }
        }
      } else { // working
        answerText = this.form.get(id).value;
      }

      answers.push(new Answer(qId, qText, qTypeText, answerText, selectedOptionIds));
    });

    this.surveyResponse = {
      id: this.survey.id,
      // fullName: this.details.controls.fullName.value,
      // email: this.details.controls.email.value,
      fullName: this.uuid,
      email: answers[this.emailField].answerText,
      submitDate: new Date(),
      answers: answers
    }
  }

  initSurvey(): void {
    this.dbService.getSurvey(this.surveyId).subscribe(
      data => {
        this.survey = data;
        this.questions = this.qcs.getQuestions(data);
        this.form = this.qcs.toFormGroup(this.questions);

        const draft = localStorage.getItem("draft");
        if (draft) {
           this.form.setValue(JSON.parse(draft));

           const draftLatestIndex = localStorage.getItem("latestIndex");
           if (draftLatestIndex) this.latestIndex = JSON.parse(draftLatestIndex);

           const draftSelectedIndex = localStorage.getItem("selectedIndex");
           if (draftSelectedIndex) this.selectedIndex = JSON.parse(draftSelectedIndex);

           const draftSubmitted = localStorage.getItem("submitted");
           if (draftSubmitted) this.submitted = JSON.parse(draftSubmitted);

           if (this.submitted) {
              this.form.disable();
           }

           const draftUUID = localStorage.getItem("uuid");
           if (draftUUID) this.uuid = JSON.parse(draftUUID);
        }

        this.form.valueChanges
           .subscribe((val) => {
              localStorage.setItem("draft", JSON.stringify(val));
              localStorage.setItem("selectedIndex", JSON.stringify(this.selectedIndex));
              localStorage.setItem("latestIndex", JSON.stringify(this.latestIndex));
              localStorage.setItem("submitted", JSON.stringify(this.submitted));
              localStorage.setItem("uuid", JSON.stringify(this.uuid));
           });

        this.isLoading = false;
      }
    )
  }

  initQuestionId() {
      this.questionCounter = 0;
  }

  incQuestionId(questions, controls, id) {
      if (this.isNumbered(questions[id-1].key) && this.showQuestion(questions[id-1], questions, controls)) {
        this.questionCounter++;
      }
  }

  countCompleted(questions, controls) {
      var count = 0;
      var total = 0;

      Object.keys(this.form.controls).forEach (key => {
         let id = (parseInt(key)-1).toString();

         if (this.showQuestion(questions[id], questions, controls)) {
            if (questions[id].required) {
              if (this.form.controls[key].valid) {
                count++;
              }
            }
            total++;
         }
      });

      return count + "/" + total;
  }

  pageCompleted(questions, start, end, controls) {

      var completed = true;

      Object.keys(this.form.controls).slice(start, end).forEach (key => {
         let id = (parseInt(key)-1).toString();
        if (questions[id].required && this.showQuestion(questions[id], questions, controls) && !this.form.controls[key].valid) {
          completed = false;
        }
      });

      return completed;
  }

  onTabChanged(event) {
      this.selectedIndex = event.index;
      return false;
  }

  previousStep(index) {
    if(this.errMsg !==''){
      this.errMsg ='';
    }
      if (index > 0) {
        this.selectedIndex = index - 1;
        if (this.selectedIndex > this.latestIndex) {
          this.latestIndex = this.selectedIndex;
        }
      }
      return false;
  }

  nextStep(index) {
      if (index < (this.paginations.length - 1)) {
        this.selectedIndex = index + 1;
        if (this.selectedIndex > this.latestIndex) {
          this.latestIndex = this.selectedIndex;
        }
      }
      return false;
  }

  restart() {
      localStorage.removeItem("draft");
      localStorage.removeItem("latestIndex");
      localStorage.removeItem("selectedIndex");
      localStorage.removeItem("submitted");
      localStorage.removeItem("reportSent");
      localStorage.removeItem("uuid");

      this.latestIndex = 0;
      this.selectedIndex = 0;
      this.submitted = 0;

      location.href = location.origin + "/ibg-eforms/sg/sustainability-accel-tool";
  }

  regenerate() {
      this.isLoading = true;

      this.dbService.generateSurveyReport(this.uuid).subscribe(data => {
         this.isLoading = true;
         location.reload();
      });
  }

  submit() {
    // log answers given by users
    // console.log(this.form.value);

    if (!this.submitted) {
      this.isLoading = true;
      this.selectedIndex = this.paginations.length-1;

      // create an object from form values, will be sent to database
      this.createObject();

      // use dbservice to save user's response
      this.dbService.saveSurveyResponse(this.surveyResponse).pipe(
        catchError(error=>{
          console.error('Error occured while saving survey response:', error);
          return throwError(()=> new Error(error.error.error));
        })
      ).subscribe({
        next: (data) => {
        // the object which we send to db service
        // console.log(this.surveyResponse);   
        this.submitted = 1;
        this.form.disable();

        localStorage.setItem("latestIndex", JSON.stringify(this.latestIndex));
        localStorage.setItem("selectedIndex", JSON.stringify(this.selectedIndex));
        localStorage.setItem("submitted", JSON.stringify(this.submitted));
        localStorage.setItem("uuid", JSON.stringify(this.uuid));

        this.isLoading = false;
		this.notLastPage = false;
        // location.reload();
      },
      error: (error)=>{         
        this.errMsg= error;
        this.selectedIndex = this.paginations.length-2;
        this.isLoading = false;	
      }});
  }

    // after survey is completed, redirect to a new page
    // this.router.navigate(['surveycompleted']);

    // can we create a new array of response to questions
    // for each respondant
    /*
    {
      fullName,
      email,
      submitDate,
      answers[]
    }
  
    // each answer
    {
      questionId
      questionType
      answer: // text for all types, for multiple choice answers we can save with some delimiter
      selectedOptionIds: 
    }
    */
  }

  private getValueFromKey(options: { key: string, value: string }[], key: string): string {
    for (let i = 0; i < options.length; i++) {
      if (options[i].key === key) {
        return options[i].value;
      }
    }
    return "N.A.";
  }
}
